import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=020a179b&scoped=true"
import script from "./panel.vue?vue&type=script&lang=ts"
export * from "./panel.vue?vue&type=script&lang=ts"
import style0 from "./panel.vue?vue&type=style&index=0&id=020a179b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a179b",
  null
  
)

export default component.exports